export default "__VITE_ASSET__763a1da1__"